<template>
  <div class="card">
    <img src="/images/loading.gif" alt="loader" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
  .card {
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
